import React from "react";
import { MAP, MARKER } from "react-google-maps/lib/constants";
import PropTypes from "prop-types";

class Spiderfy extends React.Component {
  static contextTypes = {
    [MAP]: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);
    const oms = require(`npm-overlapping-marker-spiderfier/lib/oms.min`);
    this.oms = new oms.OverlappingMarkerSpiderfier(this.context[MAP], {
      keepSpiderfied: true,
      ignoreMapClick: true,
      circleFootSeparation: 100,
      spiralFootSeparation: 100,
      spiralLengthFactor: 20,
    });
    this.markerNodeMounted = this.markerNodeMounted.bind(this);
  }

  markerNodeMounted(ref) {
    const marker = ref && ref.state[MARKER];
    if (marker) {
      this.oms.addMarker(marker);
    } else {
      return;
    }

    window.google.maps.event.addListener(marker, "spider_click", (e) => {
      if (this.props.onSpiderClick) this.props.onSpiderClick(e);
    });
  }

  render() {
    return React.Children.map(this.props.children, (child) =>
      React.cloneElement(child, { ref: this.markerNodeMounted })
    );
  }
}

export default Spiderfy;
